import { useInsertionEffect } from 'react'

// O CSS da linguagem B é dependência de quem chama este hook (as molduras do
// cliente). No ATS fica inerte: todas as regras exigem o atributo que só o hook põe.
import '@/styles/superficie-cliente.css'

/**
 * A superfície do cliente (Epic 30, #425): marca o `<html>` com
 * `data-surface="cliente"` enquanto uma moldura do cliente está montada.
 *
 * NO `<html>`, e não no contentor da moldura, pela mesma razão que o
 * `usePublicTheme` marca lá o `data-theme-scope`: o Popover e o Select do Radix
 * e os avisos do Sonner são portados para o `<body>`. Um atributo num `<div>`
 * deixava o menu do usuário e as listas de seleção no Lumen, a meio da tela B.
 *
 * ⚠️ `useInsertionEffect`, e não `useLayoutEffect`: os layout effects correm dos
 * filhos para o pai, e o `useSlidingIndicator` da navegação (filho da moldura)
 * media os links ANTES de o atributo existir — sem o estilo deles —, e a pílula
 * deslizava à vista a cada carga do portal. Os insertion effects correm antes
 * de qualquer layout effect do mesmo commit. Ao desmontar o atributo sai, e a
 * moldura seguinte, se também for do cliente, volta a pô-lo antes do paint.
 */
export const SUPERFICIE_CLIENTE = 'cliente'

export function useSuperficieCliente(): void {
  useInsertionEffect(() => {
    const html = document.documentElement
    html.dataset.surface = SUPERFICIE_CLIENTE
    return () => {
      delete html.dataset.surface
    }
  }, [])
}
